import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_public/frameworks/$slug")({
  staticData: { title: "Framework" },
  component: () => <Outlet />,
});
